import styled from 'styled-components';
import React from 'react';
import moment from 'moment';
import Widget from './Components/Widget';
import { getFunnel, mappedFunnelData, conversionMetric, disintermediationMetric, newClients } from '../../lib/DataDashboard';
import FunnelChart from './Components/FunnelChart';
import SimpleBarChart from './Components/SimpleBarChart';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
`;

const today = moment().format("YYYY-MM-DD");
const monthAgo = moment().subtract(1, 'months').format("YYYY-MM-DD");
const twoMonthAgo = moment().subtract(2, 'months').format("YYYY-MM-DD");
const twoWeeks = moment().subtract(2, 'weeks').format("YYYY-MM-DD");
const sixWeeks = moment().subtract(6, 'weeks').format("YYYY-MM-DD");

const conversionDates = [
  {start: '2019-03-01', end: '2019-06-01', label: 'Q2 2019'},
  {start: '2019-06-01', end: '2019-09-01', label: 'Q3 2019'},
  {'start': monthAgo, end: today, label: 'Last 30d'} 
];

const disintermediationDates = [
  { start: '2019-06-01', end: '2019-08-01', project_end: '2019-10-01', label: 'June-August' },
  { start: twoMonthAgo, end: monthAgo, project_end: today, label: '1 month ago (lagging indicator)'} 
];

const newClientDates = [
  { start: '2019-09-01', end: '2019-10-01', label: 'Sep 2019'},
  { start: '2019-10-01', end: '2019-11-01', label: 'Oct 2019'},
  { start: monthAgo, end: today, label:  'Last 30d'}
];

const sections = [

  {
    title: 'Sign up Funnel (Desktop)',
    id: 'sign_up',
    type: 'funnel',
    dataKeys: [
       'Before changes',
       'Oct 01',
       'Most Recent'
      ],
    steps: ['Landing Page','Click to sign up','Finish Sign Up'],
    data: [
    ],
  },
  {
    title: 'Sign up to post (Desktop)',
    id: 'sign_up_to_post',
    type: 'funnel',
    dataKeys: [ 'Before changes','Oct 01', 'Most Recent'],
    steps: ['Finish Sign Up', 'Start Project', 'Submit Project'],
    data: [
    ],
  },
  {
    title: 'Conversion: Job posted to paid',
    id: 'conversion_metric',
    subtitle: 'A role is converted if there is at least one hire, otherwise not converted',
    type: 'simple_bar',
    unit: '%',
    dataKeys: conversionDates.reduce(item => item.label),
    data: []
  },
  {
    title: 'Disintermediation Metric',
    id: 'disintermediation_metric',
    type: 'simple_bar',
    subtitle: "Ratio of (users who initiate disintermediation in a convo where neither of users is client who books job at some point in future) / (total users having convos in period)",
    unit: '%',
    data: []
  },
  {
    title: 'New Clients Metric',
    id: 'new_clients',
    subtitle: 'Users who join in time window, have been let off waitlist, and post a project at some point',
    type: 'simple_bar',
    data: []
  }

];

class DataDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: [...sections],
    };
  }

  componentDidMount() {
    // this.updateSection('sign_up','x');
    // console.log(this.state.sections);
    this.getValues();
  }

  mergeFunnelValuesFromMP = (funnel_id, new_id, funnelValues) => {
    const sections = [...this.state.sections];
    const section = sections.filter(section => section.id == funnel_id)[0];
    const rightValue = section.data;
    const valuesMapped =  mappedFunnelData(funnelValues, new_id);
    sections.filter(section => section.id == funnel_id)[0].data = section.steps.map((step, i) => Object.assign({name: step}, rightValue.filter(val => val.name == step)[0] || {}, valuesMapped.filter(val => val.name == step)[0] || {}));
    this.setState({sections});
  }

  normalizeValues = (funnel_id, new_id) => {
    const sections = [...this.state.sections];
    const maxValue = sections.filter(section => section.id == funnel_id)[0].data[0][new_id];
    sections.filter(section => section.id == funnel_id)[0].data = sections.filter(section => section.id == funnel_id)[0].data.map(datum => {
      datum[new_id] = parseFloat(datum[new_id] * 100 / maxValue).toFixed(1);
      return datum
    })
    this.setState({sections});
    
  }

  getValues = async() => {

    

    const conversionMetricValues = await conversionMetric(conversionDates );
    this.updateSection('conversion_metric', this.addLabels(conversionMetricValues.values, conversionDates.map(date => date.label)));

    const disintermediationMetricValues = await disintermediationMetric(disintermediationDates);
    this.updateSection('disintermediation_metric', this.addLabels(disintermediationMetricValues.values, disintermediationDates.map(date => date.label)));

    const newClientValues = await newClients(newClientDates);
    this.updateSection('new_clients', this.addLabels(newClientValues.values, newClientDates.map(date => date.label)));

    const firstHalfClientFunnelKPIs = await getFunnel(6871992, '2019-10-01');
    const secondHalfClientFunnelKPIs = await getFunnel(6871840, '2019-10-01');
    const firstHalfClientFunnelKPIsMostRecent = await getFunnel(6871992, null, true);
    const secondHalfClientFunnelKPIsMostRecent = await getFunnel(6871840, null, true);
    const clientJourneyBeforeImprovements = await getFunnel(6872131, '2019-05-01');

    this.mergeFunnelValuesFromMP('sign_up', 'Before changes', clientJourneyBeforeImprovements);
    this.mergeFunnelValuesFromMP('sign_up', 'Most Recent', firstHalfClientFunnelKPIsMostRecent);
    this.mergeFunnelValuesFromMP('sign_up', 'Most Recent', secondHalfClientFunnelKPIsMostRecent);
    this.mergeFunnelValuesFromMP('sign_up', 'Oct 01', secondHalfClientFunnelKPIs);
    this.mergeFunnelValuesFromMP('sign_up', 'Oct 01', firstHalfClientFunnelKPIs);

    this.mergeFunnelValuesFromMP('sign_up_to_post', 'Most Recent', firstHalfClientFunnelKPIsMostRecent);
    this.mergeFunnelValuesFromMP('sign_up_to_post', 'Most Recent', secondHalfClientFunnelKPIsMostRecent); 
    this.mergeFunnelValuesFromMP('sign_up_to_post', 'Oct 01', firstHalfClientFunnelKPIs);
    this.mergeFunnelValuesFromMP('sign_up_to_post', 'Oct 01', secondHalfClientFunnelKPIs);
    this.mergeFunnelValuesFromMP('sign_up_to_post', 'Before changes', clientJourneyBeforeImprovements);

    this.normalizeValues('sign_up', 'Before changes');
    this.normalizeValues('sign_up', 'Oct 01');
    this.normalizeValues('sign_up', 'Most Recent');
    this.normalizeValues('sign_up_to_post', 'Before changes');
    this.normalizeValues('sign_up_to_post', 'Oct 01');
    this.normalizeValues('sign_up_to_post', 'Most Recent');
  }

  updateSection = (id, data) => {
    const sections = [...this.state.sections];
    sections.filter(section => section.id == id)[0].data = data; 
    this.setState({ sections });
  }

  addLabels = (data, labels) => {
    return data.map((datum, i) => ({...datum, ...{ name: labels[i] }}));
  }

  render() {
    return (<Container>
      {
        this.state.sections.map(section => {
          return <Widget 
            title ={section.title}
            subtitle={section.subtitle || ''}>
          {
            section.type == 'funnel' && <FunnelChart 
              data = {section.data}
              dataKeys = {section.dataKeys}
            />
          }
          {
            section.type == 'simple_bar' && <SimpleBarChart 
              data = {section.data}
              unit = {section.unit || ''}
            />
          }
          </Widget>;
        })
      }
    </Container>);
  }
}

export default DataDashboard;
